import React, { useState } from "react";
import styled from "styled-components/macro";
import Devices from "../../consts/Devices";
import Sizes from "../../consts/Sizes";
import Colors from "../../consts/Colors";
import { Cta, Heading4 } from "../text-elements/index";
import { ReactComponent as Paypal } from "../../assets/svgs/paypal.svg";
import { ReactComponent as Patreon } from "../../assets/svgs/patreon.svg";
import { ReactComponent as Instagram } from "../../assets/svgs/instagram.svg";
import { ReactComponent as ExternalLink } from "../../assets/svgs/external-link.svg";

const Text = styled(Cta)`
  font-weight: normal;
  color: ${(props) =>
    props.hovered ? Colors.ehfmPrimary() : Colors.playerWhite};
  color: fill, 0.2s ease-out;
`;

const LinkText = styled(Cta)`
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: normal;
  color: ${(props) =>
    props.hovered ? Colors.ehfmPrimary() : Colors.playerWhite};
  color: fill, 0.2s ease-out;

  svg {
    margin-right: 0.5rem;
    height: 14px;
    width: auto;

    path {
      fill: ${(props) =>
    props.hovered ? Colors.ehfmPrimary() : Colors.playerWhite} !important;
      transition: fill, 0.2s ease-out;
    }

    path:nth-child(2) {
      fill: ${(props) =>
    props.hovered ? Colors.ehfmPrimary() : Colors.playerWhite} !important;
      transition: fill, 0.2s ease-out;
    }

    path:nth-child(3) {
      fill: ${(props) =>
    props.hovered ? Colors.ehfmPrimary() : Colors.playerWhite} !important;
      transition: fill, 0.2s ease-out;
    }

    path:nth-child(4) {
      fill: ${Colors.ehfmPrimary(0.8)} !important;
    }
  }
`;

const LinkWrapper = styled.div`
  border-radius: ${Sizes.buttonRadius}px;
  background-color: ${(props) =>
    props.hovered ? Colors.playerWhite : Colors.ehfmPrimary()};
  transition: background-color 0.2s ease-out;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  justify-content: start;
  align-items: start;
  width: auto;
`;

const LinkButton = ({ text, linkText, href }) => {
  let [hovered, setHovered] = useState(false);
  const getIcon = () => {
    if (!linkText) return null;

    const currentDomain = window.location.origin.toLowerCase();

    const lowerCaseLink = linkText.toLowerCase();
    if (lowerCaseLink.includes("paypal")) {
      return <Paypal />;
    }

    if (lowerCaseLink.includes("patreon")) {
      return <Patreon />;
    }

    if (lowerCaseLink.includes("instagram")) {
      return <Instagram />;
    }

    if (!lowerCaseLink.startsWith(currentDomain)) {
      return <ExternalLink />;
    }

    return null;
  };

  return (
    <LinkWrapper
      href={href}
      target="_blank"
      as="a"
      onMouseOver={() => {
        setHovered(true);
      }}
      onMouseOut={() => {
        setHovered(false);
      }}
      hovered={hovered}
    >
      {text && <Text hovered={hovered}>{text}</Text>}
      <LinkText hovered={hovered}>
        {getIcon()} {linkText}
      </LinkText>
    </LinkWrapper>
  );
};

export default LinkButton;
